import {FC, useEffect} from "react";
import {Modal} from "antd";
import {useBlocker} from "react-router";

type Props = {
    shouldBlock: () => boolean;
}

export const Blocker: FC<Props> = ({ shouldBlock }) => {
    const blocker = useBlocker(shouldBlock);

    useEffect(() => {
        const fn = (e: Event) => {
            if(shouldBlock()) {
                e.preventDefault();
                e.returnValue = true;
            }
        };

        window.addEventListener('beforeunload', fn);

        return () => window.removeEventListener('beforeunload', fn);
    }, [shouldBlock]);

    return (
        <Modal
            open={blocker.state === 'blocked'}
            title="Вы уверены что хотите выйти?"
            onOk={blocker.proceed}
            onCancel={blocker.reset}
        >
            Несохраненные изменения будут утеряны!
        </Modal>
    )
}